function refreshTabs() {
  const urlParams = new URLSearchParams(window.location.search)
  const activeTabId = urlParams.get('tab') || 'tab-1'
  const activeTab = $(`[data-tab-id='${activeTabId}']`)

  const current = $(activeTab)
  const siblings = current.parents('.switcher').find('.tab')

  siblings.removeClass('tab_active')
  current.addClass('tab_active')
}

$(window).on('load', () => {
  if (!window.location.pathname.includes('government-programs.html'))
    return

  refreshTabs()
})
